<header class="paged-header">
	<div class="paged-header__next">
		<button mat-icon-button mat-flat-button class="btn-dark"
				aria-label="Previous"
				color="primary" (click)="advance('prev')"
				[disabled]="disablePrev">
			<mat-icon title="Previous">chevron_left</mat-icon>
		</button>
	</div>
	<div class="paged-header__title">
		<h1>{{ title }}</h1>
		<span class="paged-header__pagination">
			{{ index + 1 }} of {{ length }}
		</span>
	</div>
	<div class="paged-header__previous">
		<button mat-icon-button mat-flat-button class="btn-dark"
				aria-label="Next"
				color="primary" (click)="advance('next')"
				[disabled]="disableNext">
			<mat-icon title="Next">chevron_right</mat-icon>
		</button>
	</div>
</header>
